import './style.scss';
import { TranslationService } from '../../../../services/translation.service';
import { IMicromobilityLink, MicromobilityLinkType } from '../../../../models/labs/micromobility/micromobility-link.model';
import MicromobilityHelper from '../../../TravelPlanner/helpers/micromobility.helper';

function MicromobilityTransportTrip({ className = '', micromobilityLink, showWithVehicleCount }: { className?: string; micromobilityLink: IMicromobilityLink; showWithVehicleCount: boolean }) {
  function getAvailableVehicleCount() {
    return (
      <div className="micromobility-count d-flex align-items-center justify-content-center">
        <span className="fw-bold">
          <span className="visually-hidden">{TranslationService.get('travelplanner.micromobility.numberofvehiclesavailable')}</span>
          {micromobilityLink.type === MicromobilityLinkType.stationBound ? micromobilityLink.originStation?.availableVehicles : micromobilityLink.allAvailableVehicles?.length}
        </span>
      </div>
    );
  }

  return (
    <div className={`me-1 ${className}`}>
      <div className="d-flex align-items-center">
        <img alt={MicromobilityHelper.getVehicleTypeName(micromobilityLink)} src={MicromobilityHelper.getVehicleIconSrc(micromobilityLink)} className="micromobility-icon" />
        {showWithVehicleCount && getAvailableVehicleCount()}
      </div>
    </div>
  );
}

export default MicromobilityTransportTrip;
